<template>
  <div class="footer">
    <div class="footer__logos">
      <div class="legal-links">
          <router-link :to="{ name: 'impressum' }" v-word:layout.impressum />
          |
          <router-link :to="{ name: 'contact' }" v-word:layout.contact />
      </div>
    </div>
  </div>
</template>

<script>
import * as mixins from '../mixins';
export default {
  mixins: [mixins.wordedPage],
};
</script>



// WEBPACK FOOTER //
// src/layout/Footer.vue